import React, { useEffect, useState } from "react";
import { AiOutlineHome } from "react-icons/ai";
import { CiSettings } from "react-icons/ci";
import { NavLink } from "react-router-dom";
import { useSelector } from "react-redux";
import { BsCardChecklist, BsUpload, BsGraphUp } from "react-icons/bs";
import { FaUsers } from "react-icons/fa";
import { getAuth } from "firebase/auth";
import { theme } from "../../utils/theme";
import { BiCrown } from "react-icons/bi";
import { getStatsMeetings } from "../../services/StatsMeetingService"
import { getCurrentUser, getUser } from "../../services/UserService"
import { findIfPaidUserForCrown } from "../../services/CommonService"

const Sidebar = () => {
  const [isUploadsEnabled, setIsUploadsEnabled] = useState(false);
  const [showCrown, setShowCrown] = useState(false);
  const [meetCount, setMeetCount] = useState(0);
  const auth = getAuth();
  const { userData } = useSelector((state) => state.authReducer);

  const getMeetCount = async () => {
    getStatsMeetings(
        (response) => {
          const res = response.data;
          const count = res?.processingCount;
          setMeetCount(count);
        }
    )
  };

  useEffect(() => {
    getMeetCount();
  }, []);

  useEffect(() => {
    findIfPaidUserForCrown({ setShowCrown, userData });
  }, []);

  const style =
    "flex gap-[10px] lg:text-[20px] text-[#333333] mb-[10px] px-[30px] xl:px-[60px] py-[15px] mr-[15px]";
  return (
    <div className="border-r h-[100vh]">
      <div>
        <div className={`flex items-center ${style}`}>
          {/* <div className="relative"> */}
          <img
            src={
              userData?.profile ||
              auth?.currentUser?.photoURL ||
              "https://cdn-icons-png.flaticon.com/256/149/149071.png"
            }
            className="xl:w-[50px] xl:h-[50px] h-[40px] w-[40px] rounded-full"
            alt=""
          />
          {/* {showCrown && (
              <div className="bg-white p-[5px] rounded-full absolute top-0 right-0 transform translate-x-1/2 -translate-y-1/2 shadow-md">
                <BiCrown
                  className="text-yellow-500 text-xl"
                  // You can adjust the color, size, and other styles as needed
                />
              </div>
            )} */}
          {/* </div> */}
          <div className="text-black min-w-fit flex items-center">
            <div>
              {userData?.name ? userData?.name : auth?.currentUser?.displayName}
            </div>
            {showCrown && (
              <div className="bg-white p-[5px] rounded-full ml-2">
                <BiCrown
                  className="text-yellow-500 text-3xl"
                  // style={{ backgroundColor: theme.color }}
                />
              </div>
            )}
          </div>
        </div>
      </div>
      <NavLink to="/">
        <div
          className={`${
            window.location.pathname === "/" ? "activeLink" : "normalLink"
          } ${style} s6-step`}
        >
          <AiOutlineHome className="w-[30px] h-[30px] " />
          <span>Home</span>
        </div>
      </NavLink>
      <NavLink to="/meetings">
        <div
          className={`${
            window.location.pathname === "/meetings"
              ? "activeLink"
              : "normalLink"
          } ${style} s9-step`}
        >
          <FaUsers className="w-[30px] h-[30px]" />
          <span>Meetings</span>
        </div>
      </NavLink>
      <NavLink to="/uploads">
        <div
          className={`${
            window.location.pathname === "/uploads"
              ? "activeLink"
              : "normalLink"
          } ${style}`}
        >
          <BsUpload className="w-[30px] h-[30px]" />
          <span>Uploads</span>
        </div>
      </NavLink>
      <NavLink to="/task">
        <div
          className={`s24-step ${
            window.location.pathname === "/task" ? "activeLink" : "normalLink"
          } ${style}`}
        >
          <BsCardChecklist className="w-[30px] h-[30px]" />
          <span>Tasks</span>
        </div>
      </NavLink>
      <NavLink to="/settings">
        <div
          className={`s1-step ${
            window.location.pathname === "/settings"
              ? "activeLink"
              : "normalLink"
          } ${style}`}
        >
          <CiSettings className="w-[30px] h-[30px]" /> <span>Settings</span>
        </div>
      </NavLink>
      {
      userData?.organisation_info?.organisation_role == "organisation_admin" && (
        <NavLink to="/reports">
          <div
            className={`${
              window.location.pathname === "/reports"
                ? "activeLink"
                : "normalLink"
            } ${style}`}
          >
            <BsGraphUp className="w-[30px] h-[30px]" />
            <span>Reports</span>
          </div>
        </NavLink>
      )
      }
      <div className="p-[10px] bg-[#07457f] text-white text-sm sm:text-base rounded-xl w-[90%] mx-auto text-center">
        <div>{meetCount || 0}+ meetings summarised</div>
        <div>worldwide!</div>
      </div>
    </div>
  );
};

export default Sidebar;
